(() => {
  angular
    .module('gm.common.services')
    .factory('gmCashout', gmCashoutService);

  function gmCashoutService(
    gmApi
  ) {
    'ngInject';

    return {
      addWireCashout,
      deleteCashout,
      getCashoutSettings,
      update,
    };

    function addWireCashout(id, vaultIds, percentage) {
      return gmApi.post('cashout-settings/bankWire', {
        id,
        cashout: {
          vaultIds,
          percentage
        }
      }, {
        auth: true
      });
    }

    function deleteCashout(id) {
      return gmApi.delete(`cashout-settings/${id}`, {
        auth: true
      });
    }

    function getCashoutSettings() {
      return gmApi.get('cashout-settings')
        .then(data => data.cashoutSettings);
    }

    function update({
      id, percentage, vaultIds
    }) {
      return gmApi.put(`cashout-settings/${id}`, {
        percentage,
        vaultIds
      }, {
        auth: true
      });
    }
  }
})();
